export default "__VITE_ASSET__BlbWuNMi__"